import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

type Size = 'sm' | 'md' | 'lg';

interface AvatarProps {
  name: string;
  size?: Size;
}

const SIZES = {
  sm: { box: 28, font: 10.5 },
  md: { box: 48, font: 15 },
  lg: { box: 72, font: 22 },
} as const;

const Circle = styled.div<{ size: Size }>(({ size }) => ({
  width: SIZES[size].box,
  height: SIZES[size].box,
  flex: 'none',
  borderRadius: '50%',
  background: t.color.accentSoft,
  color: t.color.statusActiveText,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: t.font,
  fontSize: SIZES[size].font,
  fontWeight: 700,
  letterSpacing: '0.3px',
  userSelect: 'none',
}));

/**
 * Iniciales del nombre: la primera palabra y la última.
 *
 * Los nombres de la plantilla suelen traer dos apellidos, y tomar las dos
 * primeras palabras daría la inicial del nombre compuesto en vez de la del
 * apellido.
 */
const initialsOf = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  if (words.length === 1) return words[0].charAt(0).toUpperCase();

  return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
};

/**
 * Primitivo: círculo con las iniciales de una persona.
 *
 * No hay fotografía de empleado en el sistema, así que la identidad visual son
 * las iniciales. Los tres tamaños cubren la barra superior, la tarjeta y el
 * encabezado de la ficha.
 */
const Avatar = ({ name, size = 'md' }: AvatarProps) => (
  <Circle size={size} aria-hidden="true">
    {initialsOf(name)}
  </Circle>
);

export default Avatar;
